export enum ScriveStandardProcessingAction {
  ReturnToPrepare = 0,
  Cancel = 1,
  SendForSigning = 2,
  CancelSigning = 3
}
